<template>
  <div class="event-card skeleton">
    <div class="event-image-wrapper shimmer"></div>
    <div class="event-content">
      <div class="event-header">
        <div class="event-title shimmer short"></div>
        <div class="event-sub shimmer"></div>
      </div>
      <div class="event-description shimmer long"></div>
      <div class="event-description shimmer long"></div>
      <div class="event-description shimmer short"></div>
    </div>
  </div>
</template>

<style scoped>

.event-card {
  display: flex;
  border-bottom: 1px solid #ccc;
  padding-bottom: 32px;
  margin-bottom: 32px;
}

.event-image-wrapper {
  width: 360px;
  height: 240px;
  border-radius: 8px;
  background-color: #e0e0e0;
  flex-shrink: 0;
  margin-right: 24px;
}

.event-content {
  flex: 1;
}

.event-title,
.event-sub,
.event-description {
  background-color: #e0e0e0;
}

.event-title {
  height: 24px;
  width: 50%;
  margin-bottom: 12px;
  border-radius: 4px;
}

.event-sub {
  height: 16px;
  width: 30%;
  margin-bottom: 24px;
  border-radius: 4px;
}

.event-description {
  height: 16px;
  margin-bottom: 12px;
  border-radius: 4px;
}

.short {
  width: 30%;
}

.long {
  width: 90%;
}

.shimmer {
  animation: shimmer 1.5s infinite linear;
  background: linear-gradient(
    to right,
    #eeeeee 0%,
    #dddddd 20%,
    #eeeeee 40%,
    #eeeeee 100%
  );
  background-size: 1000px 100%;
}

[data-theme="dark"] .event-image-wrapper,
[data-theme="dark"] .event-title,
[data-theme="dark"] .event-sub,
[data-theme="dark"] .event-description {
  background-color: #2c2c2c;
}

[data-theme="dark"] .shimmer {
  background: linear-gradient(
    to right,
    #2a2a2a 0%,
    #3c3c3c 20%,
    #2a2a2a 40%,
    #2a2a2a 100%
  );
}

@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}
</style>